<mat-select
  panelClass="app-select-panel"
  [value]="linkedSelectedOption()"
  (selectionChange)="onSelectionChange($event.value)"
  disableRipple
>
  <mat-select-trigger>
    <span class="flex items-center gap-2 max-w-[200px]">
      @if (icon()) {
      <mat-icon
        fontSet="material-icons"
        class="flex-none !text-[20px] !w-[20px] !h-[20px]"
      >
        {{ icon() }}
      </mat-icon>
      }
      <span class="truncate">{{ linkedSelectedOption() }}</span>
      <mat-icon
        fontSet="material-icons"
        class="flex-none !text-[20px] !w-[20px] !h-[20px]"
        >keyboard_arrow_down</mat-icon
      >
    </span>
  </mat-select-trigger>
  @for (option of options(); track option) {
  <mat-option [value]="option"> {{ option }} </mat-option>
  }
</mat-select>
